import * as actionTypes from "../actionTypes";

const initialState = {
  cachedAvailableSolutions: [],
  persistIn: "session"
};

export default function solutionsCacheReducer(state = initialState, action) {
  let data = action.data;
  switch (action.type) {
    case actionTypes.SET_SOLUTIONSCACHE:
      return {
        ...state,
        cachedAvailableSolutions: data
      };
    case actionTypes.CLEAR_SOLUTIONSCACHE:
      return initialState;
    default:
      return state;
  }
}
